export const formatPercent = (value) => {
  const numericValue = typeof value === 'number' ? value : +value
  return Number(numericValue * 100).toFixed(2)
}
